import { Component } from 'preact';

import { LoaderTemplate } from 'common/module/loader/template';
import { LoaderTemplatePropsInterface } from 'common/module/loader/template-props.interface';

export class LoaderComponent extends Component<LoaderTemplatePropsInterface, LoaderTemplatePropsInterface> {
  /**
   * Constructor
   */
  constructor(props: LoaderTemplatePropsInterface) {
    super(props);

    this.setState(props);
  }

  /**
   * Render component
   */
  public render(): preact.JSX.Element {
    return LoaderTemplate(this.props);
  }
}
